<div *ngIf="subscriptionGrouping && syllabusInfo">
<h4 class="text-center sunrise-header"> {{subscriptionGrouping['name']}} </h4>
<h5 class="text-center sunrise-header" *ngIf="subscriptionGrouping"> Modifying for {{subscriptionGrouping.name}}  </h5>
<div id="accordionSubjThemes" class="max-width" *ngIf="syllabusInfo && subscriptionGrouping">
    <div *ngFor="let topic of syllabusInfo.topics; index as myCount;" class="card" >

      <div class="card-header" id="headingTheme{{topic.id}}">
        <a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
        <h5 class="mb-0">
        <span *ngIf="topic.isOpen">
          <span *ngIf="topic.hasTemplates">

              <input *ngIf="topic.isSelected" type="checkbox" name="topic" value="{{topic.id}}" checked (change)="updateQuizAreaItem(topic.id)"/>
              <input *ngIf="!topic.isSelected" type="checkbox" name="topic" value="{{topic.id}}" (change)="updateQuizAreaItem(topic.id)"/>
          </span>
          <i *ngIf="!topic.hasTemplates" class="fa fa-square text-secondary"></i>
          <span [appMath]="topic.name"></span> {{topic.name}}
          </span>
          <span *ngIf="!topic.isOpen">
            <i class="fa fa-square-o text-primary"></i> {{topic.name}}
          </span>
        </h5>
      </a>
      </div>

      <div id="collapseTheme{{topic.id}}" class="collapse {{myCount==0?'show':''}}" aria-labelledby="headingTheme{{topic.id}}" data-parent="#accordionSubjThemes">
        <div class="card-body">
         <app-subscription-grouping-modify-subtopic
         [topic]="topic"
         [subscriptionGrouping]="subscriptionGrouping"></app-subscription-grouping-modify-subtopic>
        </div>
      </div>

  </div>
  </div>
  <div class="text-center mt-4" *ngIf="!newQuizRequest">
    <a [routerLink]="['/batch/grouping/quiz/list',subscriptionGrouping.server_subscription_grouping_id]" class='btn btn-primary me-2'> Ok</a>
  </div>
</div>

